import React from 'react';
import { DrawerHeader, DrawerBody, DrawerFooter, Button, Input, Label, OverlayDrawer, SearchBox } from '@fluentui/react-components';
import ProtocolSelectorComponent from '../../../../../../commons/component/Inputs/ProtocolSelector/ProtocolSelectorComponent';
import { CurrencySelectorComponent } from '../../../../../../commons/component/Inputs/CurrencySelector/CurrencySelectorComponent';
import ProtocolConsumptionStatusSelectorComponent from '../../../../../../commons/component/Inputs/ProtocolConsumptionStatusSelector/ProtocolConsumptionStatusSelector.Component';
import { Protocol } from '../../../../../../models/Entities/Protocols/Protocol';
import { IConsumptionStatusProps } from '../../../../../../commons/component/Inputs/ProtocolConsumptionStatusSelector/ProtocolConsumptionStatusSelector.Functions';
import DateRangeSelectorComponent from '../../../../../../commons/component/Inputs/DateRangeSelector/DateRangeSelector.Component';
import { IConsumptionsFilters } from '../../../../../../models/Filters/ConsumptionsFilters';

interface Props {
  isOpen: boolean;
  Filters: IConsumptionsFilters;
  onClose: () => void;
  onFilterChange: (filters: IConsumptionsFilters) => void;
}

const PractitionerFilterPanelComponent = (props: Props) => {
  const { isOpen, Filters, onClose, onFilterChange } = props;
  const [filterText, setFilterText] = React.useState<string>(Filters.FilterText ?? '');
  const [selectedProtocols, setSelectedProtocols] = React.useState<Protocol[]>(Filters.SelectedProtocols ?? []);
  const [selectedCurrency, setSelectedCurrency] = React.useState<string>(Filters.SelectedCurrencys ?? '');
  const [selectedStatus, setSelectedStatus] = React.useState<IConsumptionStatusProps[]>(Filters.SelectedStatus ?? []);
  const [startDate, setStartDate] = React.useState<Date | undefined>(Filters.SelectedDateRange[0] ?? undefined);
  const [endDate, setEndDate] = React.useState<Date | undefined>(Filters.SelectedDateRange[1] ?? undefined);

  const handleDateChange = (start: Date | undefined, end: Date | undefined) => {
    setStartDate(start);
    setEndDate(end);
  };

  const handleApply = () => {
    onFilterChange({
      ...Filters,
      FilterText: filterText,
      SelectedProtocols: selectedProtocols,
      SelectedCurrencys: selectedCurrency,
      SelectedStatus: selectedStatus,
      SelectedDateRange: [startDate, endDate]      
    });
    onClose();
  };

  return (
    <OverlayDrawer open={isOpen} position="end" onOpenChange={handleApply}>
      <DrawerHeader>Filtros</DrawerHeader>
      <DrawerBody>
        <div style={{ marginBottom: 16 }}>
          <SearchBox value={filterText} style={{width: '100%'}} onChange={(_, data) => setFilterText(data.value)} />	
        </div>
        <div style={{ marginBottom: 16 }}>
          <ProtocolSelectorComponent
            selectionLimit={undefined}
            onChangeSelection={(selectedProtocols: Protocol[] | undefined) => selectedProtocols ? setSelectedProtocols(selectedProtocols) : setSelectedProtocols([])}
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <Label>Moneda</Label>
          <CurrencySelectorComponent
            defaultSelected={selectedCurrency}
            onCurrencyChange={setSelectedCurrency}
            label={''}
            errorMessage={undefined}
            disabled={false}
            isRequired={false}
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <ProtocolConsumptionStatusSelectorComponent
            ContractId={0}
            onSelectedStatus={setSelectedStatus}
            statusSelected={selectedStatus?.map((s: any) => s.id)}
            MultiselectEnable={true}
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <Label>Rango de fechas</Label>
          <DateRangeSelectorComponent
            startDate={startDate}
            endDate={endDate}
            onDateChange={handleDateChange}
            startDateLabel={"Desde"}
            endDateLabel={"Hasta"}
            className={"ConsumptionFilterDateRangeElement"}
          />
        </div>
      </DrawerBody>
      <DrawerFooter>
        <Button onClick={onClose} appearance="secondary">Cancelar</Button>
        <Button onClick={handleApply} appearance="primary">Aplicar</Button>
      </DrawerFooter>
    </OverlayDrawer>
  );
};

export default PractitionerFilterPanelComponent;
